export default __webpack_public_path__ + "static/pentest360-52c151e821a36fc2ab28309b2c3e260c.png";